<app-page-heading [heading]="'Execute Payment'"
                  [hasBackButton]="true"
                  [backPageName]="'claim-management'"
                  [tabName]="'payments'">
</app-page-heading>

<div class="stepper-container">
  <mat-horizontal-stepper [linear]="true" #stepper>

    <!---------------------------->
    <!-- STEP: Payment Parameters:-->
    <!---------------------------->

    <mat-step [completed]="paymentParameterFormGroup.valid">
      <ng-template matStepLabel>Payment Parameters</ng-template>
      <form [formGroup]="paymentParameterFormGroup">

        <div class="flex flex-wrap justify-between mt2 mb2">
          <!-- Processing Class -->
            <div class="flex items-center">
              <mat-form-field class="w-100">
                <mat-label>Processing Class</mat-label>
                <mat-select [formControl]="processingClassFormControl"
                            (selectionChange)="processingClassSelectionChange()" required>
                  <mat-option *ngFor="let processingClass of processingClasses" [value]="processingClass">
                    {{processingClass}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Processing Class')">help_outline</mat-icon>
            </div>

          <!-- Sub-Class -->
            <div class="flex items-center">
              <app-element-select
                displayLabel='Sub-Class'
                [defaultValue]="processingSubClass"
                [options]="getSubClasses()"
                [required]="true"
                (selectionChanged)="onProcessingSubClassSelectionChanged($event)">
              </app-element-select>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Sub-Class')">help_outline</mat-icon>
            </div>

          <!-- Payee Type -->
            <div class="flex items-center">
              <mat-form-field class="w-100">
                <mat-label>Payee Type</mat-label>
                <mat-select [formControl]="payeeTypeFormControl"
                            (selectionChange)="payeeTypeSelectionChange()" required>
                  <mat-option *ngFor="let payeeType of payeeTypes" [value]="payeeType">
                    {{payeeType}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Payee Type')">help_outline</mat-icon>
            </div>

          <!-- Product -->
            <div class="flex items-center">
              <mat-form-field class="w-100">
                <mat-label>Product</mat-label>
                <mat-select [formControl]="productFormControl" required multiple>
                  <mat-option #allSelected (click)="toggleAllSelection()" [value]="allProducts.name" selected>
                    {{allProducts.name}}
                  </mat-option>
                  <mat-option (click)="productSelectionChange(true)"
                             *ngFor="let product of getProducts()"
                             [value]="product.name">
                    {{product.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Product')">help_outline</mat-icon>
          </div>

          <!-- Claims From -->
            <div class="flex items-center">
              <mat-form-field class="w-100">
                <mat-label>Claims From</mat-label>
                <input [formControl]="claimFromDateFormControl"
                       (dateChange)="dateFromSelectionChange()"
                       [max]="claimToDateFormControl.value"
                       [matDatepicker]="fromDatePicker"
                       matInput required>
                <mat-datepicker-toggle [for]="fromDatePicker" matIconSuffix>
                </mat-datepicker-toggle>
                <mat-datepicker #fromDatePicker></mat-datepicker>
              </mat-form-field>
          </div>

          <!-- Claims To -->
            <div class="flex items-center">
              <mat-form-field class="w-100">
                <mat-label>Claims To</mat-label>
                <input [formControl]="claimToDateFormControl"
                       (dateChange)="dateToSelectionChange()"
                       [min]="claimFromDateFormControl.value"
                       [matDatepicker]="toDatePicker"
                       matInput required>
                <mat-datepicker-toggle [for]="toDatePicker" matIconSuffix>
                </mat-datepicker-toggle>
                <mat-datepicker #toDatePicker></mat-datepicker>
              </mat-form-field>
              <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Claims Range')">help_outline</mat-icon>
          </div>
        </div>

        <!-- Row-2 -->
        <mat-grid-list cols="5" rowHeight="50px">
          <mat-grid-tile>
            <mat-slide-toggle [formControl]="showUpfrontPaidFormControl" (change)="onUpfrontPaidToggleToggle($event)">
              Show upfront paid claims?
            </mat-slide-toggle>
          </mat-grid-tile>
        </mat-grid-list>

        <!-- Row-3 -->
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile class="mat-primary-color">
            <h3>Select Payers</h3>
          </mat-grid-tile>
          <mat-grid-tile class="mat-primary-color">
            <h3>Select Payees</h3>
          </mat-grid-tile>
        </mat-grid-list>

        <!-- Row-4 -->
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile class="w-48">
            <input class="search-box search-box-shadow" placeholder="Filter payers by name" matInput type="text"
                   [formControl]="payerNameFormControl" (input)="onInputChangedSearchPayers($event.target.value)">
          </mat-grid-tile>

          <mat-grid-tile class="w-48">
            <input class="search-box search-box-shadow" placeholder="Filter payees by last name" matInput type="text"
                   [formControl]="payeeNameFormControl" (input)="onInputChangedSearchPayees($event.target.value)">
          </mat-grid-tile>
        </mat-grid-list>

        <!-- Row-5 -->
        <mat-grid-list cols="2">
          <mat-grid-tile class="drop-box-container-wrapper padding-top-18 w-48">
            <div class="display-contents">
              <div class="drop-box-container">
                <div class="text-center">Available Payers</div>
                <div
                  class="drop-box-list"
                  cdkDropList
                  #todoList="cdkDropList"
                  [cdkDropListData]="availablePayers"
                  [cdkDropListConnectedTo]="[doneList]"
                  (cdkDropListDropped)="dropPayer($event)">
                  <div class="drop-box-list-item" *ngFor="let item of availablePayers" cdkDrag>{{item.name}}</div>
                </div>
              </div>

              <div class="drop-box-container">
                <div class="text-center">Selected Payers</div>
                <div
                  class="drop-box-list"
                  cdkDropList
                  #doneList="cdkDropList"
                  [cdkDropListData]="selectedPayers"
                  [cdkDropListConnectedTo]="[todoList]"
                  (cdkDropListDropped)="dropPayer($event)">
                  <div class="drop-box-list-item" *ngFor="let item of selectedPayers" cdkDrag>{{item.name}}</div>
                </div>
              </div>
            </div>
          </mat-grid-tile>

          <mat-grid-tile class="drop-box-container-wrapper padding-top-18 w-48">
            <div class="display-contents">
              <div class="drop-box-container">
                <div class="text-center">Available Payees</div>
                <div
                  class="drop-box-list"
                  cdkDropList
                  #todoList1="cdkDropList"
                  [cdkDropListData]="availablePayees"
                  [cdkDropListConnectedTo]="[doneList1]"
                  (cdkDropListDropped)="dropPayee($event)">
                  <div class="drop-box-list-item" *ngFor="let item of availablePayees"
                       cdkDrag> {{item.name}}</div>
                </div>
              </div>

              <div class="drop-box-container">
                <div class="text-center">Selected Payees</div>
                <div
                  class="drop-box-list"
                  cdkDropList
                  #doneList1="cdkDropList"
                  [cdkDropListData]="selectedPayees"
                  [cdkDropListConnectedTo]="[todoList1]"
                  (cdkDropListDropped)="dropPayee($event)">
                  <div class="drop-box-list-item" *ngFor="let item of selectedPayees"
                       cdkDrag> {{item.name}}</div>
                </div>
              </div>
              <div class="remove-all-add-all-button-settings">
                <a mat-button (click)="addAllPayeesToSelectedList()">
                  <small>ADD ALL >></small>
                </a>
                <a mat-button (click)="clearSelectedPayees()">
                  <small><< REMOVE ALL</small>
                </a>
              </div>
            </div>
          </mat-grid-tile>
        </mat-grid-list>

        <div class="button-container">
          <button mat-raised-button color="warn" (click)="clearForm()">Clear</button>
          <button mat-raised-button color="primary" (click)="loadClaims()">Next</button>
        </div>
      </form>
    </mat-step>

    <!---------------------------->
    <!-- STEP: Selected Claims:-->
    <!---------------------------->

    <mat-step>
      <ng-template matStepLabel>Selected Claims</ng-template>
      <mat-grid-list cols="3" rowHeight="75px">
        <mat-grid-tile>
          <div class="full-width">
            <app-content-field [label]="'Total Amount'"
                               [content]="totalAmount | number: '.2'"></app-content-field>
          </div>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-form-field class="w-45">
            <mat-label>From Bank Account</mat-label>
            <mat-select [formControl]="fromBankAccountFormControl" required>
              <mat-option *ngFor="let bankAccount of fromBankAccounts" [value]="getFromBankAccountDisplayString(bankAccount)">
                {{getFromBankAccountDisplayString(bankAccount)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-icon class="info-icon padding-right-1vw" [matTooltip]="getInfoTooltip('From Bank Account')">help_outline</mat-icon>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-form-field class="w-45">
            <mat-label>Payment Execution Date</mat-label>
            <input [formControl]="executionDateFormControl"
                   [min]="today" [matDatepicker]="executionDatePicker" matInput required>
            <mat-datepicker-toggle [for]="executionDatePicker" matIconSuffix>
            </mat-datepicker-toggle>
            <mat-datepicker #executionDatePicker></mat-datepicker>
          </mat-form-field>
          <mat-icon [matTooltip]="getInfoTooltip('Payment Execution Date')" class="info-icon">help_outline</mat-icon>
        </mat-grid-tile>
      </mat-grid-list>
      <div *ngIf="transactionDataSource" class="mat-elevation-z8 table-container">

        <table class="full-width" mat-table [dataSource]="transactionDataSource" matSort
               (matSortChange)="sortData($event)">

          <ng-container matColumnDef="select" style="width: 36px">
            <th *matHeaderCellDef mat-header-cell >
            </th>
            <td *matCellDef="let row" mat-cell style="width: 36px">
              <mat-checkbox (click)="$event.stopPropagation()"
                            (change)="toggleSelect($event, row)"
                            [checked]="isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="icons">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row" mat-cell>
              <mat-icon class="table-icon font-medium" matTooltip="VIEW Details"
                        (click)="viewClaimDetails($event, row.transactionId)">info
              </mat-icon>
              <mat-icon *ngIf="allowReview(row)" class="table-icon font-medium" matTooltip="REVIEW Claim"
                        (click)="reviewClaim($event, row.transactionId)">rate_review
              </mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="transactionId">
            <th *matHeaderCellDef mat-header-cell> ID</th>
            <td *matCellDef="let row" mat-cell> {{row.transactionId}}</td>
          </ng-container>

          <ng-container matColumnDef="processingClass">
            <th *matHeaderCellDef mat-header-cell> CLASS</th>
            <td *matCellDef="let row" mat-cell> {{row.processingClass}}</td>
          </ng-container>

          <ng-container matColumnDef="receivedDate">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>RECEIVED DATE</th>
            <td *matCellDef="let row" mat-cell> {{row.receiveDate | date: dateFormat}}</td>
          </ng-container>

          <ng-container matColumnDef="insuredPersonName">
            <th *matHeaderCellDef mat-header-cell> MEMBER</th>
            <td *matCellDef="let row" mat-cell> {{row.insuredPersonName}}</td>
          </ng-container>
          <ng-container matColumnDef="insuredPersonBankAccount">
            <th *matHeaderCellDef mat-header-cell> MEMBER ACCOUNT</th>
            <td *matCellDef="let row" mat-cell>
              <div class="flex justify-start items-baseline">
                <app-open-link-as [icon]="DisplayIcon.DialogIcon"
                                  (onClick)="openInsuredPersonBankAccountDialog($event, row.insuredPersonId)">
                </app-open-link-as>
                <p>{{getBankAccountDisplayString(row.insuredPersonBankAccount)}}</p>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="beneficiaryName">
            <th *matHeaderCellDef mat-header-cell> BENEFICIARY</th>
            <td *matCellDef="let row" mat-cell> {{row.beneficiaryName}}</td>
          </ng-container>

          <ng-container matColumnDef="beneficiaryBankAccount">
            <th *matHeaderCellDef mat-header-cell> BENEFICIARY ACCOUNT</th>
            <td *matCellDef="let row" mat-cell>
              <div class="flex justify-start items-baseline">
                <app-open-link-as [icon]="DisplayIcon.DialogIcon"
                                  (onClick)="openInsuredPersonBankAccountDialog($event, row.beneficiaryId)">
                </app-open-link-as>
                <p>{{getBankAccountDisplayString(row.beneficiaryBankAccount)}}</p>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="providerName">
            <th *matHeaderCellDef mat-header-cell> PROVIDER</th>
            <td *matCellDef="let row" mat-cell> {{row.providerName}}</td>
          </ng-container>
          <ng-container matColumnDef="providerBankAccount">
            <th *matHeaderCellDef mat-header-cell> PROVIDER ACCOUNT</th>
            <td *matCellDef="let row" mat-cell>
              <app-open-link-as [icon]="DisplayIcon.DialogIcon"
                                (onClick)="openProviderBankAccountDialog($event, row.providerId)">
              </app-open-link-as>
              <p>{{getProviderBankAccountDisplayString(row.providerBankAccount)}}</p>
            </td>
          </ng-container>

          <ng-container matColumnDef="policyNumber">
            <th *matHeaderCellDef mat-header-cell> POLICY</th>
            <td *matCellDef="let row" mat-cell> {{row.policyNumber}}: {{row.policyName | slice : 0 : 20}}</td>
          </ng-container>

          <ng-container matColumnDef="caseNumber">
            <th *matHeaderCellDef mat-header-cell> CASE</th>
            <td *matCellDef="let row" mat-cell class="font-small">
              <app-open-link-as [url]="getCaseUrl(row)" (onClick)="$event.stopPropagation()"></app-open-link-as>
              <p>{{row.caseNumber}} : {{row.caseDescription | slice : 0 : 20}}</p>
            </td>
          </ng-container>

          <ng-container matColumnDef="assessingStatus">
            <th *matHeaderCellDef mat-header-cell mat-sort-header> ADJUDICATION STATUS</th>
            <td *matCellDef="let row" mat-cell> {{row.assessingStatus}}</td>
          </ng-container>

          <ng-container matColumnDef="payTo">
            <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-5">PAY</th>
            <td *matCellDef="let row" mat-cell
                [matTooltip]="(row.transactionType == ClaimType.CLAIM ? row.payTo : null)">
              {{(row.transactionType == ClaimType.CLAIM ? ClmFunctions.getPayToAcronym(row.payTo) : null)}}
            </td>
          </ng-container>

          <ng-container matColumnDef="casePayments">
            <th *matHeaderCellDef mat-header-cell mat-sort-header class="w-5">Pre-Payments</th>
            <td *matCellDef="let row" mat-cell>
              <div class="flex justify-start items-baseline">
                <ng-container *ngIf="row?.casePayments">
                  <app-open-link-as [icon]="DisplayIcon.DialogIcon"
                                    (onClick)="onClickOpenPaymentLedgerReport($event,row)">
                  </app-open-link-as>
                </ng-container>
                {{row.casePayments}}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="benefitAmount">
            <th *matHeaderCellDef mat-header-cell> BENEFIT AMOUNT</th>
            <td *matCellDef="let row" mat-cell> {{row.benefitAmount | number: '.2'}}</td>
          </ng-container>

          <ng-container matColumnDef="netAmountForCase">
            <th *matHeaderCellDef mat-header-cell> NET DUE ON CASE</th>
            <td *matCellDef="let row" mat-cell> {{(row.netAmountForCase == null ? 0 : row.netAmountForCase) | number: '.2'}}</td>
          </ng-container>

          <ng-container matColumnDef="payAmount">
            <th *matHeaderCellDef mat-header-cell> PAY AMOUNT</th>
            <td *matCellDef="let row" mat-cell> {{(row.payAmount == null ? 0 : row.payAmount) | number: '.2'}}</td>
          </ng-container>

          <ng-container matColumnDef="warn">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row" mat-cell class="text-center">
              <ng-container *ngIf="row.payerWarning == 1">
                <mat-icon [matTooltip]="'The payer on the claim is different to the payer in the cardholder file'"
                          class="table-icon font-medium"
                          style="color: orange">
                  warning
                </mat-icon>
              </ng-container>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="transactionDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: transactionDisplayedColumns;"></tr>

        </table>

        <mat-paginator #transactionPaginator (page)="pageChanged($event)"
                       [length]="transactionTableControl.length"
                       [pageSize]="transactionTableControl.pageSize"
                       [pageIndex]="0"
                       [pageSizeOptions]="transactionTableControl.pageSizeOptions">
        </mat-paginator>

      </div>
      <div class="button-container" [matTooltip]="getFinishTooltip()" [matTooltipDisabled]="!disableFinishButton()">
        <button #backButton mat-raised-button matStepperPrevious color="primary">Back</button>
        <button #finishButton [disabled]="disableFinishButton()" mat-raised-button color="primary"
                (click)="executePayment()">Finish
        </button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>



